<template lang="pug">
  .mapaResumo(:id="idMapa" :style="height ? {'height' : height + 'vh'} : ''")
</template>

<script>
import _ from 'lodash'
import L from 'leaflet'
import AppDeflate from '../mixins/AppDeflate'
import HelperTopoJson from '../../static/topoJsonHelper'
import { mapState } from 'vuex'

export default {
  name: 'AppResumoMapa',
  mixins: [
    AppDeflate
  ],

  props: {
    localizacoes: {
      type: Array,
      required: true
    },
    idMapa: {
      type: String,
      default: 'mapaResumo'
    },
    isVisualizarCadastro: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number
    }
  },

  data () {
    return {
      mapa: {},
      url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      zoom: 6,
      featureGroup: new L.FeatureGroup(),
      removedFeatures: new L.FeatureGroup(),
      validExtensions: ['.zip']
    }
  },

  computed: {
    ...mapState({
      center: state => state.userInterface.dadosEstado.COORDENADAS_ESTADO
    })
  },

  async mounted () {
    this.createComponent()
  },

  methods: {

    async createComponent () {
      window.setTimeout(() => {
        this.featureGroup = new L.FeatureGroup()
        this.createMapa()
        _.each(this.localizacoes, (localizacao) => {
          if (typeof localizacao === 'string') {
            localizacao = JSON.parse(localizacao)
          }
          this.addGeometry(localizacao)
        })
        this.mapa.addLayer(this.featureGroup)
        this.mapa.fitBounds(this.featureGroup.getBounds().pad(0.6))
      }, 100)
    },

    createMapa () {
      if (Object.keys(this.mapa).length === 0) {
        this.mapa = L.map(this.idMapa, {
          zoomControl: this.isVisualizarCadastro,
          dragging: true,
          doubleClickZoom: this.isVisualizarCadastro,
          attributionControl: false
        }).setView(this.center, this.zoom)

        this.mapa.options.minZoom = 6
        this.mapa.options.maxZoom = 16
        this.mapa.addLayer(L.tileLayer(this.url))
        this.mapa.scrollWheelZoom.disable()
        this.mapa.addLayer(this.featureGroup)
      }
      this.mapa.scrollWheelZoom.disable()
      this.mapa.on('click', () => {
        if (this.mapa.scrollWheelZoom.enabled()) {
          this.mapa.scrollWheelZoom.disable()
        } else {
          this.mapa.scrollWheelZoom.enable()
        }
      })
      this.$nextTick().then(() => {
        HelperTopoJson.getTopoJson().then((layerMunicipios) => {
          this.mapa.addLayer(layerMunicipios)
        })
      })
    },

    addGeometry (geojson) {
      const that = this
      L.geoJSON(geojson, {
        onEachFeature (feature, layer) {
          if (feature.type === 'Point') {
            layer = L.marker([feature.coordinates[1], feature.coordinates[0]]); // eslint-disable-line
          }
          that.featureGroup.addLayer(layer)
        }
      })
    }
  }
}
</script>

<style scoped>
.mapaResumo {
  height: 65vh;
  width: 100%;
  z-index: 1;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoMapa.vue